import React, { useState, useEffect, useMemo } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import './Catering.css';
import Silk from './Silk';
import SplitText from './SplitText';
import caterImg from './home3.jpg';
import subImg from './menu/ham.png';
import londonImg from './menu/broil.png';
import turkeyImg from './menu/turkey.png';
import veggieImg from './menu/veggie.png';
import italianImg from './menu/italian.png';
import cubanImg from './menu/cuban.png';
import hamImg from './menu/ham.png';

import bbqImg from './menu/bbq.png';
import seasaltImg from './menu/seasalt.png';
import jalapenoImg from './menu/jalapeno.png';
import onionImg from './menu/onion.png';


import chipImg from './chip.png';
import cookieImg from './ccc.png';
import waterImg from './water.png';
import cokeImg from './coke.png';
import dietImg from './diet.png';
import spriteImg from './sprite.png';
import dewImg from './dew.png';
import fantaImg from './fanta.png';
import { CircularProgress, Dialog, Button } from '@mui/material';
import ClientPaymentForm from './ClientPaymentForm';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import StarIcon from '@mui/icons-material/Star';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { IconButton } from '@mui/material';
import { Add, Remove, ExpandMore, ExpandLess, SentimentDissatisfied } from '@mui/icons-material';
import Lottie from 'lottie-react';
import addedAnimation from './added.json';

const MAX_PER_TRAY = 20;
const TRAY_PRICE = 65.99;

const Catering = () => {
  const [ready, setReady] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentName, setPaymentName] = useState('');
  const [paymentEmail, setPaymentEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [orderNumber, setOrderNumber] = useState('');
  const [readyTime, setReadyTime] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showAdded, setShowAdded] = useState(false);
  
  // Tip state
  const [tipPercentage, setTipPercentage] = useState(null); // 10, 15, 20, or null for custom
  const [customTipAmount, setCustomTipAmount] = useState("");



  
  const handleCheckout = () => {
    setPaymentName(fullName);
    setPaymentEmail(eventEmail);
    setTipPercentage(null);
    setCustomTipAmount('');
    setShowPayment(true);
  };

// Helper to format date as dd/MM/yyyy
function formatDateDDMMYYYY(date) {
  if (!date || !(date instanceof Date) || isNaN(date)) return '';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

  const [subs, setSubs] = useState([
    { name: 'London Broil', count: 0, img: londonImg },
    { name: 'Turkey Club', count: 0, img: turkeyImg },
    { name: 'Veggie', count: 0, img: veggieImg },
    { name: 'Italian', count: 0, img: italianImg },
    { name: 'Cuban', count: 0, img: cubanImg },

    { name: 'Virginia Ham', count: 0, img: hamImg },
  ]);

  const [sides, setSides] = useState([
    { name: 'BBQ Chips', count: 0, price: 1.75, img: bbqImg },
    { name: 'Sea Salt Chips', count: 0, price: 1.75, img: seasaltImg },
    { name: 'Jalapeno Chips', count: 0, price: 1.75, img: jalapenoImg },
    { name: 'Sweet Maui Onion Chips', count: 0, price: 1.75, img: onionImg },
    { name: 'Cookies', count: 0, price: 2.00, img: cookieImg },
  ]);

  const [drinks, setDrinks] = useState([
    { name: 'Water', count: 0, price: 1.75, img: waterImg },
    { name: 'Coke', count: 0, price: 1.75, img: cokeImg },
    { name: 'Diet Coke', count: 0, price: 1.75, img: dietImg },
    { name: 'Sprite', count: 0, price: 1.75, img: spriteImg },
    { name: 'Mountain Dew', count: 0, price: 1.75, img: dewImg },

  ]);

  const [fullName, setFullName] = useState('');
  const [eventDate, setEventDate] = useState(null);
  const [pickupTime, setPickupTime] = useState('');

  // Generate time slots every half hour from 11:00 AM to 3:00 PM
  const pickupSlots = [];
  for (let h = 11; h <= 15; h++) {
    for (let m = 0; m < 60; m += 30) {
      if (h === 15 && m > 0) continue;
      const hour12 = h > 12 ? h - 12 : h;
      const ampm = h >= 12 ? 'PM' : 'AM';
      const min = m === 0 ? '00' : '30';
      pickupSlots.push(`${hour12}:${min} ${ampm}`);
    }
  }
  const [eventEmail, setEventEmail] = useState('');
  // Use require for page background (matching your latest)
  const home4Img = require('./e12.jpg');

  const [openSides, setOpenSides] = useState(false);
  const [openDrinks, setOpenDrinks] = useState(false);

  const updateSubs = (index, value) => {
    const newSubs = [...subs];
    newSubs[index].count = Math.max(0, value);
    setSubs(newSubs);
  };

  const updateSides = (index, value) => {
    const newSides = [...sides];
    newSides[index].count = Math.max(0, value);
    setSides(newSides);
  };

  const updateDrinks = (index, value) => {
    const newDrinks = [...drinks];
    newDrinks[index].count = Math.max(0, value);
    setDrinks(newDrinks);
  };

  const totalSubs = subs.reduce((sum, s) => sum + s.count, 0);
  const fullTrays = Math.floor(totalSubs / MAX_PER_TRAY);
  const spotsOpen = MAX_PER_TRAY - (totalSubs % MAX_PER_TRAY === 0 ? MAX_PER_TRAY : totalSubs % MAX_PER_TRAY);
  const remaining = totalSubs % MAX_PER_TRAY;
  const trayPrice = fullTrays * TRAY_PRICE + (remaining > 0 ? TRAY_PRICE : 0);
  const sidesPrice = sides.reduce((sum, s) => sum + s.count * (s.price || 0), 0);
  const drinksPrice = drinks.reduce((sum, d) => sum + d.count * (d.price || 0), 0);
  const totalPrice = trayPrice + sidesPrice + drinksPrice;
  
  // Calculate tip based on selection
  const calculateTip = (subtotal) => {
    if (tipPercentage) {
      return (subtotal * tipPercentage / 100);
    } else if (customTipAmount && !isNaN(parseFloat(customTipAmount))) {
      return (subtotal * parseFloat(customTipAmount) / 100);
    }
    return 0;
  };
  
  const tipAmount = useMemo(() => calculateTip(totalPrice), [totalPrice, tipPercentage, customTipAmount]);
  
  // Tampa sales tax 7.5% - calculated on subtotal + tip
  const salesTaxRate = 0.075;
  const salesTax = useMemo(() => +((totalPrice + tipAmount) * salesTaxRate).toFixed(2), [totalPrice, tipAmount]);
  const grandTotal = totalPrice + tipAmount + salesTax;
  
  const currency = (n) => `$${n.toFixed(2)}`;

  const canCheckout =
    totalSubs >= MAX_PER_TRAY &&
    spotsOpen === 0 &&
    fullName.trim().length > 0 &&
    eventEmail.trim().length > 0 &&
    eventDate &&
    pickupTime;

  useEffect(() => {
    const img = new Image();
    img.src = caterImg;
    img.onload = () => setReady(true);
  }, []);

  const [showCater, setShowCater] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCater(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${home4Img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '40px'
      }}
    >
      {/* <div className="catering-bg">
        <Silk speed={5} scale={1} color="#7B7481" noiseIntensity={1.5} rotation={0} />
      </div> */}

      <div className="catering-card">
        <div className="catering-banner">
          {showCater && (
            <SplitText
              text="We Cater!"
              className="catering-title"
              delay={100}
              duration={0.6}
              ease="power3.out"
              splitType="chars"
              from={{ opacity: 0, y: 40 }}
              to={{ opacity: 1, y: 0 }}
            />
          )}
        </div>

        <div className="catering-img-container">
          <img src={caterImg} alt="Catering" className="catering-img" />

          <div className="catering-desc-card">
            <p className="catering-sub">
              Order your favorite Mickey’s Subs sandwiches to cater your next party, corporate,
              business, or special event! Made fresh to order on our Cuban bread, using the finest
              Boars Head meats and fresh veggies. We can feed as many as you need!
            </p>

            <p className="catering-section-title">Design Your Trays ($65.99 Each)</p>
            <p className="catering-sub">Each tray comes with 20 party size subs.</p>


            <div className="form-group">
              <label style={{ fontFamily: 'FontSemi', color: 'black' }}>Pickup Location:</label>
              <div className="pickup-location-box">
                All catering orders will be picked up at:<br />
                <strong>5230 Bridge St, Tampa, FL 33611</strong>
              </div>
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'FontSemi', color: 'black' }}>Pick a Date (at least 1 week in advance):</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Pick a date"
                  value={eventDate}
                  onChange={(newValue) => {
                    setEventDate(newValue instanceof Date && !isNaN(newValue) ? newValue : null);
                  }}
                  minDate={(() => {
                    const minDate = new Date();
                    minDate.setDate(minDate.getDate() + 7);
                    return minDate;
                  })()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      sx: { background: '#fff', color: '#000' },
                      inputProps: { style: { color: '#000' } }
                    }
                  }}
                  format="dd/MM/yyyy"
                />
              </LocalizationProvider>
              {/* Pickup time slots below date */}
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 10,
                marginTop: 12,
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                paddingBottom: 4,
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch'
              }}>
                {pickupSlots.map((slot) => (
                  <div
                    key={slot}
                    onClick={() => setPickupTime(slot)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: 8,
                      background: pickupTime === slot ? '#3AC28E' : '#eafaf4',
                      color: pickupTime === slot ? 'white' : '#188a5b',
                      fontWeight: 600,
                      fontFamily: 'FontSemi',
                      fontSize: 15,
                      cursor: 'pointer',
                      border: pickupTime === slot ? '2px solid #188a5b' : '2px solid #eafaf4',
                      boxShadow: pickupTime === slot ? '0 2px 8px rgba(60,194,142,0.10)' : 'none',
                      transition: 'all 0.15s',
                      marginBottom: 4
                    }}
                  >
                    {slot}
                  </div>
                ))}
              </div>
            </div>
                        <div className="form-group">
              <label style={{ fontFamily: 'FontSemi', color: 'black' }}>Full Name:</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter your full name"
              />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'FontSemi', color: 'black' }}>Email:</label>
              <input
                type="email"
                value={eventEmail}
                onChange={(e) => setEventEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </div>


            {subs.map((sub, index) => (
              <div key={index} className="sub-row">
                <img src={sub.img} alt={sub.name} className="sub-img" />
                <span className="sub-label">{sub.name}</span>
                <IconButton onClick={() => updateSubs(index, sub.count - 1)}>
                  <Remove />
                </IconButton>
                <input
                  type="number"
                  value={sub.count === 0 ? "" : sub.count}
                  placeholder="0"
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "") {
                      updateSubs(index, 0);
                    } else {
                      const parsed = parseInt(val, 10);
                      updateSubs(index, isNaN(parsed) ? 0 : parsed);
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value === "") {
                      updateSubs(index, 0);
                    }
                  }}
                />
                <IconButton onClick={() => updateSubs(index, sub.count + 1)}>
                  <Add />
                </IconButton>
              </div>
            ))}

            <div className="summary">
              {totalSubs === 0 ? (
                <p>No trays yet, start adding subs!</p>
              ) : (
                <p>
                  {spotsOpen === 0
                    ? `${fullTrays} tray${fullTrays > 1 ? 's' : ''} full!`
                    : `${fullTrays + 1} tray${fullTrays + 1 > 1 ? 's' : ''} ordered with ${spotsOpen} spot${spotsOpen !== 1 ? 's' : ''} still open!`}
                </p>
              )}
            </div>

            <div className={`accordion ${openSides ? 'open' : ''}`}>
              <div className="accordion-header" onClick={() => setOpenSides(!openSides)}>
                <span>Sides (Chips $1.75, Cookies $2.00)</span>
                {openSides ? <ExpandLess /> : <ExpandMore />}
              </div>
              {openSides && (
                <div className="accordion-content">
                  {sides.map((side, index) => (
                    <div key={index} className="sub-row">
                      <img src={side.img} alt={side.name} className="sub-img" />
                      <span className="sub-label">{side.name}</span>
                      <IconButton onClick={() => updateSides(index, side.count - 1)}>
                        <Remove />
                      </IconButton>
                      <input
                        type="number"
                        value={side.count}
                        onChange={(e) => updateSides(index, parseInt(e.target.value) || 0)}
                      />
                      <IconButton onClick={() => updateSides(index, side.count + 1)}>
                        <Add />
                      </IconButton>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className={`accordion ${openDrinks ? 'open' : ''}`}>
              <div className="accordion-header" onClick={() => setOpenDrinks(!openDrinks)}>
                <span>Drinks ($1.75 Each)</span>
                {openDrinks ? <ExpandLess /> : <ExpandMore />}
              </div>
              {openDrinks && (
                <div className="accordion-content">
                  {drinks.map((drink, index) => (
                    <div key={index} className="sub-row">
                      <img src={drink.img} alt={drink.name} className="sub-img" />
                      <span className="sub-label">{drink.name}</span>
                      <IconButton onClick={() => updateDrinks(index, drink.count - 1)}>
                        <Remove />
                      </IconButton>
                      <input
                        type="number"
                        value={drink.count}
                        onChange={(e) => updateDrinks(index, parseInt(e.target.value) || 0)}
                      />
                      <IconButton onClick={() => updateDrinks(index, drink.count + 1)}>
                        <Add />
                      </IconButton>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
              <button
                className="checkout-btn"
                onClick={handleCheckout}
                disabled={!canCheckout}
                style={{
                  background: !canCheckout ? '#ccc' : '#3AC28E',
                  color: !canCheckout ? '#888' : '#fff',
                  fontWeight: 700,
                  fontSize: 18,
                  border: 'none',
                  borderRadius: 8,
                  padding: '12px 32px',
                  cursor: !canCheckout ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                }}
              >
                Checkout: ${totalPrice.toFixed(2)}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Dialog */}
      <Dialog open={showPayment} onClose={() => {
        setShowPayment(false);
        setTipPercentage(null);
        setCustomTipAmount('');
      }} fullWidth maxWidth="sm">
        <div style={{ padding: 24 }}>
          <h2 style={{ fontFamily: 'FontSemi', marginBottom: 16 }}>Payment</h2>
          {/* Unified Promo Section with three bullets and a title */}
          <div style={{
            background: 'linear-gradient(90deg, #222 0%, #3AC28E 100%)',
            borderRadius: 14,
            padding: '22px 24px',
            marginBottom: 22,
            color: 'white',
            boxShadow: '0 4px 16px rgba(60,194,142,0.10)',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 17,
            fontWeight: 500,
          }}>
            <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 14, letterSpacing: 0.2 }}>Download our app!</div>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <CreditCardIcon style={{ fontSize: 22, marginRight: 10, color: 'white' }} />
                Save your card details and streamline checkout!
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <StarIcon style={{ fontSize: 22, marginRight: 10, color: 'white' }} />
                Earn rewards and get exclusive offers in the app!
              </li>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <LocalShippingIcon style={{ fontSize: 22, marginRight: 10, color: 'white' }} />
                Or order delivery powered by <span style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline', marginLeft: 4 }}>DoorDash</span>!
              </li>
            </ul>
            <div style={{ display: 'flex', gap: 16, marginTop: 18 }}>
              <Button
                variant="contained"
                startIcon={<img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg" alt="Apple" style={{ width: 20, height: 20 }} />}
                style={{
                  background: '#fff',
                  color: '#222',
                  fontWeight: 600,
                  borderRadius: 10,
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: 15,
                  padding: '10px 22px',
                  boxShadow: 'none',
                  textTransform: 'none',
                  border: '2px solid #222',
                }}
                href="https://apps.apple.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download on iPhone
              </Button>
              <Button
                variant="contained"
                startIcon={<img src="https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg" alt="Android" style={{ width: 20, height: 20 }} />}
                style={{
                  background: '#fff',
                  color: '#222',
                  fontWeight: 600,
                  borderRadius: 10,
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: 15,
                  padding: '10px 22px',
                  boxShadow: 'none',
                  textTransform: 'none',
                  border: '2px solid #222',
                }}
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download on Android
              </Button>
            </div>
          </div>
          <hr style={{ border: 'none', borderTop: '1.5px solid #e0e0e0', margin: '24px 0 24px 0' }} />
          <div style={{ width: '100%', display: 'block', margin: 0, padding: 0 }}>
            <div style={{ fontFamily: 'FontSemi', fontSize: 22, color: '#111', marginBottom: 2, fontWeight: 700, letterSpacing: 0.2 }}>
              Checkout Details
            </div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#444', marginBottom: 20, marginTop: 2 }}>
              Enter your name, email, and card details below to complete your order.
            </div>
            {/* First Name and Email fields */}
            <div style={{ width: '80%', margin: '0 0 18px 0', display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'flex-start' }}>
              <input
                type="text"
                placeholder="First Name"
                value={paymentName}
                onChange={e => setPaymentName(e.target.value)}
                style={{
                  width: '75%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  fontSize: 15,
                  fontFamily: 'Montserrat, sans-serif',
                }}
              />
              <input
                type="email"
                placeholder="Email"
                value={paymentEmail}
                onChange={e => setPaymentEmail(e.target.value)}
                style={{
                  width: '75%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  fontSize: 15,
                  fontFamily: 'Montserrat, sans-serif',
                }}
              />
              
              {/* Tip Section */}
              <div style={{ width: '75%', marginTop: 8 }}>
                <label style={{ fontFamily: 'FontSemi', fontSize: 15, color: '#333', display: 'block', marginBottom: 8 }}>
                  Add a Tip (Optional)
                </label>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                  <button
                    onClick={() => {
                      setTipPercentage(10);
                      setCustomTipAmount('');
                    }}
                    style={{
                      padding: '8px 16px',
                      border: tipPercentage === 10 ? '2px solid #3AC28E' : '1px solid #ddd',
                      borderRadius: 8,
                      backgroundColor: tipPercentage === 10 ? '#e0f4ed' : 'white',
                      color: tipPercentage === 10 ? '#3AC28E' : '#333',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    10%
                  </button>
                  <button
                    onClick={() => {
                      setTipPercentage(15);
                      setCustomTipAmount('');
                    }}
                    style={{
                      padding: '8px 16px',
                      border: tipPercentage === 15 ? '2px solid #3AC28E' : '1px solid #ddd',
                      borderRadius: 8,
                      backgroundColor: tipPercentage === 15 ? '#e0f4ed' : 'white',
                      color: tipPercentage === 15 ? '#3AC28E' : '#333',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    15%
                  </button>
                  <button
                    onClick={() => {
                      setTipPercentage(20);
                      setCustomTipAmount('');
                    }}
                    style={{
                      padding: '8px 16px',
                      border: tipPercentage === 20 ? '2px solid #3AC28E' : '1px solid #ddd',
                      borderRadius: 8,
                      backgroundColor: tipPercentage === 20 ? '#e0f4ed' : 'white',
                      color: tipPercentage === 20 ? '#3AC28E' : '#333',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    20%
                  </button>
                  <button
                    onClick={() => {
                      setTipPercentage(null);
                      if (!customTipAmount) setCustomTipAmount('5');
                    }}
                    style={{
                      padding: '8px 16px',
                      border: tipPercentage === null && customTipAmount ? '2px solid #3AC28E' : '1px solid #ddd',
                      borderRadius: 8,
                      backgroundColor: tipPercentage === null && customTipAmount ? '#e0f4ed' : 'white',
                      color: tipPercentage === null && customTipAmount ? '#3AC28E' : '#333',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    Other
                  </button>
                </div>
                {tipPercentage === null && (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <span style={{ fontSize: 13, color: '#666', fontFamily: 'Montserrat, sans-serif' }}>Custom Tip</span>
                      <span style={{ fontSize: 15, fontWeight: 600, color: '#3AC28E', fontFamily: 'Montserrat, sans-serif' }}>{customTipAmount || 0}%</span>
                    </div>
                    <input
                      type="range"
                      min="0"
                      max="30"
                      step="1"
                      value={customTipAmount || 0}
                      onChange={e => setCustomTipAmount(e.target.value)}
                      style={{
                        width: '100%',
                        height: 6,
                        borderRadius: 3,
                        outline: 'none',
                        WebkitAppearance: 'none',
                        background: `linear-gradient(to right, #3AC28E 0%, #3AC28E ${(customTipAmount || 0) * 100 / 30}%, #ddd ${(customTipAmount || 0) * 100 / 30}%, #ddd 100%)`,
                        cursor: 'pointer'
                      }}
                    />
                  </div>
                )}
              </div>
              
              {/* Order Summary */}
              <div style={{ width: '75%', marginTop: 24, padding: '16px', backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0' }}>
                <div style={{ fontFamily: 'FontSemi', fontSize: 16, color: '#111', marginBottom: 12 }}>
                  Order Summary
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#333' }}>Subtotal</span>
                  <span style={{ fontFamily: 'FontSemi', fontSize: 15, color: '#3AC28E' }}>
                    {currency(totalPrice)}
                  </span>
                </div>
                
                {(tipPercentage || customTipAmount) && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#333' }}>
                      Tip ({tipPercentage || customTipAmount}%)
                    </span>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#333' }}>
                      {currency(tipAmount)}
                    </span>
                  </div>
                )}
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#333' }}>Sales Tax (7.5%)</span>
                  <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 15, color: '#333' }}>
                    {currency(salesTax)}
                  </span>
                </div>
                
                <div style={{ borderTop: '2px solid #ddd', paddingTop: 12, marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontFamily: 'FontSemi', fontSize: 18, color: '#111', fontWeight: 700 }}>Total</span>
                  <span style={{ fontFamily: 'FontSemi', fontSize: 18, color: '#111', fontWeight: 700 }}>
                    {currency(grandTotal)}
                  </span>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }}>
              <ClientPaymentForm
                amount={Math.round(grandTotal * 100)}
                name={paymentName}
                email={paymentEmail}
                orderId={`catering_${Date.now()}_${Math.floor(Math.random() * 10000)}`}
                items={[...subs.filter(s => s.count > 0).map(s => ({ name: s.name, count: s.count, type: 'sub' })), ...sides.filter(s => s.count > 0).map(s => ({ name: s.name, count: s.count, type: 'side' })), ...drinks.filter(d => d.count > 0).map(d => ({ name: d.name, count: d.count, type: 'drink' }))]}
                totalItems={totalSubs + sides.reduce((sum, s) => sum + s.count, 0) + drinks.reduce((sum, d) => sum + d.count, 0)}
                totalPrice={Math.round(totalPrice * 100)}
                salesTax={Math.round(salesTax * 100)}
                tip={Math.round(tipAmount * 100)}
                finalTotal={Math.round(grandTotal * 100)}
                totalPoints={0}
                status="active"
                orderType="catering"
                pickupTime={pickupTime}
                eventDate={eventDate ? eventDate.toISOString() : null}
                onSuccess={() => {
                  setShowPayment(false);
                  setTipPercentage(null);
                  setCustomTipAmount('');
                  setShowAdded(true);
                  setTimeout(() => setShowAdded(false), 2000);
                }}
                onError={(err) => {
                  console.error(err);
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>

      {showAdded && (
        <div className="overlay">
          <div className="lottie-wrapper">
            <div className="lottie-card">
              <Lottie animationData={addedAnimation} loop={false} style={{ width: 120, height: 120 }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Catering;
